import React, {useEffect} from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import {Box, IconButton} from "@mui/material";
import {EnrichedSocialContentPublication, SocialPlatformNames} from "../../types/socialTypes";
import {useTheme} from "../../contexts/theme";
import DeleteIcon from "@mui/icons-material/Delete";
import {formatUTCDate} from "../../utils/dateTimeutils";

interface PublicationHistoryProps {
    rows: EnrichedSocialContentPublication[];
    onPublicationDelete?: (socialPostId: string) => void;
}

export const PublicationHistory: React.FC<PublicationHistoryProps> = ({ rows, onPublicationDelete = () => {}}) => {

    const theme = useTheme();


    const columns: GridColDef[] = [
        { field: 'social_content_name', headerName: 'Type', width: 200 },
        { field: 'social_account_name', headerName: 'Account', width: 200 },
        { field: 'social_platform_name', headerName: 'Platform', width: 150 },
        { field: 'status', headerName: 'Status', width: 130 },
        { field: 'published_at', headerName: 'Published At', width: 180 },
        { field: 'aspect_ratio', headerName: 'Aspect Ratio', width: 130 },
        { field: 'like', headerName: 'Like', width: 100 },
        { field: 'view', headerName: 'View', width: 100 },
        { field: 'comment', headerName: 'Comment', width: 100 },
        { field: 'share', headerName: 'Share', width: 100 },
        { field: 'save', headerName: 'Save', width: 100 },
        {
            field: 'actions',
            headerName: '',
            width: 40,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <Box width={'100%'} display={'flex'} justifyContent={'center'}>
                    {params.row.social_platform_name !== SocialPlatformNames.instagram && <IconButton
                        aria-label="delete"
                        sx={{color: theme.palette.white}}
                        onClick={() => onPublicationDelete(params.row.content_publication_id)}
                    >
                        <DeleteIcon />
                    </IconButton>}
                </Box>
            ),
        },
    ];

    return (
        <Box>
            <DataGrid
                getRowId={(row) => row.content_publication_id}
                rows={rows}
                columns={columns}
                pageSizeOptions={[10, 15, 20, 25, 30]}
                disableRowSelectionOnClick
                sx={{
                    '& .MuiDataGrid-cell': {
                        color: theme.palette.white
                    },
                    '& .MuiTablePagination-root': {
                        color: theme.palette.white
                    },
                }}
            />
        </Box>
    );
};